import i18n from './i18n';

export const FlashDefinition = {
  networkError: {
    context: [{ detail: i18n.networkError }],
    status: 'error',
  },
};
